import React, { useState } from 'react';
import Modal from '../Modal';
import Button from '../../ui/buttons/Button';
import Input from '../../ui/inputs/Input';
import { File, FileDown, Upload, X } from 'lucide-react';
import { useToast } from '../../ui/toast/ToastContext';
import SpreadsheetUploadInput from '../../ui/buttons/SpreadsheetUploadInput';
import { fetchWithCsrf } from '../../../utils/fetchWithCsrf';

const ImportFinancialsModal = ({ clientId, scope, onClose, onSuccess }) => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const [file, setFile] = useState(null);
  const [columns, setColumns] = useState({
    cnpj: 'CNPJ',
    code: 'Código de Negociação',
    isinCode: 'Código ISIN',
    isPersonal: 'É bem particular?',
    quantity: 'Quantidade',
    averagePrice: 'Preço Médio',
    grossValue: 'Valor Total',
    financialType: 'Tipo',
    modality: 'Origem',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setColumns((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      addToast({ type: 'error', message: 'Selecione uma planilha para importar.' });
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(columns));
    formData.append('scope', scope);

    try {
      const res = await fetchWithCsrf(`/app/planner/client/${clientId}/dashboard/properties/financials/import`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.message || 'Erro ao importar planilha');

      addToast({
        type: 'success',
        message: `Importados: ${json.imported}. Falhas: ${json.failed_count || 0}`,
      });
      onClose();
      onSuccess();
    } catch (err) {
      addToast({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className="p-10">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3 text-blueDarker font-jost text-2xl font-semibold">
            <Upload size={24} className="text-tealMedium" />
            Importar Planilha
          </div>
          <button onClick={onClose}>
            <X size={24} className="text-tealBase" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 font-jost text-sm">
          <div className="col-span-2">
            <SpreadsheetUploadInput
              onFileSelect={(selectedFile) => {
                console.log('Arquivo recebido:', selectedFile);
                setFile(selectedFile);
              }}
            />
          </div>
          <h2 className="col-span-2 text-lg font-semibold text-blueDarker mb-4">
            Indique em qual coluna da planilha está cada informação
          </h2>
          <Input name="cnpj" label="Nome" value={columns.cnpj} onChange={handleChange} required />
          <Input name="code" label="Código de Negociação" value={columns.code} onChange={handleChange} required />
          <Input name="quantity" label="Quantidade" value={columns.quantity} onChange={handleChange} required />
          <Input name="grossValue" label="Valor Total" value={columns.grossValue} onChange={handleChange} required />
          <Input name="modality" label="Origem" value={columns.modality} onChange={handleChange} required />
          <Input name="financialType" label="Tipo" value={columns.financialType} onChange={handleChange} required />

          <div className="md:col-span-2 flex justify-end mt-4 items-center">
            <span>
              <a
                href="https://res.cloudinary.com/rio-claro-investimentos/raw/upload/7hq0u7g1o93ffvlxc2dibar2jxsu.xlsx"
                download
                className="mr-4 text-sm text-tealBase underline hover:text-tealLight flex items-center gap-1"
              >
                <FileDown size={16} />
                Baixar modelo de planilha
              </a>
            </span>
            <Button disabled={loading} type="submit">
              IMPORTAR PLANILHA
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ImportFinancialsModal;
